export default {
  setVersionBack: (state, payload) => (state.back = payload)
};
